import axios from "../http";

class Calculation {
  /* 计算客户快递费用 */
  static getClientCostCalculation(customerId, carrierId, address, weight) {
    const url = `/zwy/api/order/calculate/traffic/income?customerId=${customerId}&carrierId=${carrierId}&address=${address}&weight=${weight}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 计算承运商快递费用 */
  static getLogisticObjCostCalculation(warehouseId, carrierId, address, weight) {
    const url = `/zwy/api/order/calculate/traffic/express?warehouseId=${warehouseId}&carrierId=${carrierId}&address=${address}&weight=${weight}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Calculation;